import { AxiosResponse } from 'axios'
import { ApiResponse, serverFailure, Validator } from './responses'
export interface AxiosApiResponseHandler<D> {
  (response: Promise<AxiosResponse<any>>): ApiResponse<D>
}

export const axiosApiResponse = <D>(
  validator: Validator<D>
): AxiosApiResponseHandler<D> => axiosResponse =>
  axiosResponse
    .then(response => {
      if (response.status >= 400)
        throw serverFailure(response.status, response.data.message)
      else return validator(response.data)
    })
    .catch(e => {
      if (
        (e as any) &&
        (e as any).error &&
        (e as any).error.formErrors &&
        (e as any).error.formErrors.length > 0
      ) {
        throw new Error((e as any).error.formErrors.join(', '))
      } else if (
        (e as any) &&
        (e as any).error &&
        (e as any).error.fieldErrors &&
        Object.keys((e as any).error.fieldErrors).length > 0
      ) {
        const errorList = []
        Object.values((e as any).error.fieldErrors).forEach((err: string[]) => {
          errorList.push(err.join(', '))
        })
        throw new Error(errorList.join(' | '))
      }
      throw serverFailure(-1, 'The call to the server failed.')
    })
